// extracted by mini-css-extract-plugin
export default {"glass":"Booking_glass__Nc9F2","titleBox":"Booking_titleBox__MyOyE","singleColumnBox":"Booking_singleColumnBox__LYNjj"};